import styled, { css } from 'styled-components';

import colors from '../../../../../styles/colors';

const textColor = ({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: ${({ $isDesktop }) => ($isDesktop ? '760px' : '480px')};
  margin: 0 auto;
  padding: ${({ $isDesktop }) => ($isDesktop ? '40px 0' : '20px 16px 24px')};
  box-sizing: border-box;
`;

const OfferCard = styled.section`
  display: grid;
  grid-template-columns: ${({ $isDesktop }) => ($isDesktop ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)')};
  overflow: hidden;
  border-radius: 20px;
  background-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark1 : colors.base.alpha)};
  ${({ $isDarkTheme }) => !$isDarkTheme && css`
    border: 1px solid ${colors.shades.gamma3};
  `}
`;

const CoachMedia = styled.div`
  position: relative;
  min-height: ${({ $isDesktop }) => ($isDesktop ? '100%' : '200px')};
  background-color: ${colors.shades.dark2};
  display: flex;
  align-items: flex-end;
`;

const CoachImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CoachCaption = styled.div`
  position: relative;
  width: 100%;
  padding: 12px 16px;
  background-color: rgba(13, 14, 16, 0.6);
  color: ${colors.base.alpha};
  font-size: 14px;
  font-weight: 600;
`;

const OfferBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 24px;
  ${({ $isCentered }) => $isCentered && css`
    text-align: center;
  `}
`;

const Overline = styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.primary : colors.base.secondary)};
`;

const Title = styled.h1`
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 1.2;
  color: ${textColor};
`;

const Description = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.shades.gamma14};
`;

const PriceRow = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
`;

const Price = styled.span`
  font-size: 32px;
  font-weight: 600;
  color: ${textColor};
`;

const OriginalPrice = styled.s`
  font-size: 20px;
  color: ${colors.shades.gamma14};
`;

const PriceUnit = styled.span`
  font-size: 16px;
  color: ${colors.shades.gamma14};
`;

const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const DeclineButton = styled.button`
  min-height: 44px;
  border: none;
  background: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  color: ${textColor};
`;

const Fineprint = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: ${colors.shades.gamma14};
`;

export {
  Container,
  OfferCard,
  CoachMedia,
  CoachImage,
  CoachCaption,
  OfferBody,
  Overline,
  Title,
  Description,
  PriceRow,
  Price,
  OriginalPrice,
  PriceUnit,
  Actions,
  DeclineButton,
  Fineprint,
};
